import React, { useState, useEffect } from 'react';
import { WifiOff, Wifi } from 'lucide-react';

const NetworkStatus = () => {
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [showBanner, setShowBanner] = useState(!navigator.onLine);

  useEffect(() => {
    const handleOnline = () => {
      setIsOnline(true);
      // Hide banner after 3 seconds when back online
      setTimeout(() => setShowBanner(false), 3000);
    };

    const handleOffline = () => {
      setIsOnline(false);
      setShowBanner(true);
    };

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  if (!showBanner) return null;

  return (
    <div 
      className={`fixed top-0 left-0 right-0 z-[9999] py-3 px-4 text-center text-sm font-medium transition-all duration-300 ${
        isOnline 
          ? 'bg-green-500/90 text-white' 
          : 'bg-red-500/90 text-white'
      }`}
      dir="rtl"
    >
      <div className="flex items-center justify-center gap-2">
        {isOnline ? (
          <>
            <Wifi className="w-4 h-4" />
            <span>تم استعادة الاتصال بالإنترنت</span>
          </>
        ) : (
          <>
            <WifiOff className="w-4 h-4 animate-pulse" />
            <span>لا يوجد اتصال بالإنترنت - الإدراج لن يُحفظ. يرجى تسجيل الخروج والتأكد من الاتصال ثم الدخول مجدداً.</span>
          </>
        )}
      </div>
    </div>
  );
};

export default NetworkStatus;
